import { useEffect } from 'react';
import { useAppDispatch } from './redux';

/**
 * Hook to handle network recovery events and trigger soft app refresh
 * instead of page reloads when network connectivity is restored.
 */
export const useNetworkRecovery = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const handleNetworkRecovery = (_event: CustomEvent) => {
      console.log('🌐 Network recovery detected, performing soft app refresh...');
      
      // Trigger any necessary app state refreshes
      // This could include:
      // - Refreshing auth state
      // - Refetching critical data
      // - Clearing error states
      // - Resuming suspended operations
      
      try {
        // Example: Clear any error states in Redux
        // dispatch(clearErrors());
        
        // Example: Refetch critical app data
        // dispatch(refreshDashboardData());
        
        console.log('✅ Soft app refresh completed');
        
        // Show success notification
        showNetworkRecoverySuccess();
        
      } catch (error) {
        console.error('❌ Soft app refresh failed:', error);
      }
    };

    // Listen for network recovery events
    window.addEventListener('network-recovery', handleNetworkRecovery as EventListener);

    // Cleanup
    return () => {
      window.removeEventListener('network-recovery', handleNetworkRecovery as EventListener);
    };
  }, [dispatch]);
};

/**
 * Show a brief success notification when network recovery completes
 */
function showNetworkRecoverySuccess() {
  const notification = document.createElement('div');
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: linear-gradient(135deg, #10b981, #059669);
    color: white;
    padding: 12px 16px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 9999;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    font-size: 14px;
    max-width: 300px;
    opacity: 0;
    transform: translateX(100%);
    transition: all 0.3s ease;
  `;
  
  notification.innerHTML = `
    <div style="display: flex; align-items: center; gap: 8px;">
      <div style="font-size: 18px;">✅</div>
      <div>
        <div style="font-weight: 500;">Connection Restored</div>
        <div style="font-size: 12px; opacity: 0.9;">Everything is back online</div>
      </div>
    </div>
  `;
  
  document.body.appendChild(notification);
  
  // Animate in
  requestAnimationFrame(() => {
    notification.style.opacity = '1';
    notification.style.transform = 'translateX(0)';
  });
  
  // Auto-hide after 3 seconds
  setTimeout(() => {
    notification.style.opacity = '0';
    notification.style.transform = 'translateX(100%)';
    setTimeout(() => {
      notification.remove();
    }, 300);
  }, 3000);
}